import { apiGet } from '../../api'

export const get_user_assets = () => {
  return apiGet({
    endpoint: 'asset/get_user_assets'
  })
}
